module.exports = __webpack_public_path__ + "img/运动装备-11.f5c3662a.png";